import { useCallback, useContext, useEffect, useState } from 'react';
import { ActivePageContext } from '@trinity/chat-components/components/Chat/context';
import { usePage } from '@trinity/chat-components/hooks/usePage';
import { SidePanelExpandedContext } from './context';

type Props = {
  children: React.ReactNode;
};

export const SidePanelContainer = (props: Props) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const { pageId: activePageId } = useContext(ActivePageContext);
  const { data: page } = usePage(activePageId);

  const resolveExpandedState = useCallback(() => {
    if (['custom_dashboard', 'dashboard', 'third_party'].includes(page?.type ?? '')) {
      setIsExpanded(true);
      return;
    }
    setIsExpanded(false);
  }, [page]);

  useEffect(() => {
    resolveExpandedState();
  }, [resolveExpandedState]);

  return (
    <SidePanelExpandedContext.Provider value={[isExpanded, setIsExpanded]}>
      {props.children}
    </SidePanelExpandedContext.Provider>
  );
};
